import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import ScreenHeader from "../ScreenHeader";
import PropTypes from "prop-types";
import TeamOption from "./TeamOption";
import "./TeamSize.scss";

const TeamSize = (props) => {
    const [teamSize, setTeamSize] = useState(props.teamSize? props.teamSize : "");
    const { validate, onValidate, firstName } = props;

    const handleChange = (value) => {
        setTeamSize(value);
    };

    const validator = () => {
        return onValidate({
            isValid: !!teamSize,
            teamSize
        });
    };

    useEffect(() => {
        validator();
    });

    return (
        <Container className="team-size-form">
            <Row>
                <ScreenHeader
                    heading={`How big is ${firstName}'s Organization?`}
                    subHeading="Your selection will not affect plans or pricing."
                />
            </Row>
            <Row>
                <Col xs="10" style={{ marginLeft: "0px", paddingLeft: "0px"}}
                    className={`${validate && !teamSize ? "noItemsSelected" : "teamSizeSelected"}`}>
                    <div className={`toast-notification ${validate && !teamSize ? "noItemsSelected" : "teamSizeSelected"}`}>
                        <p className="toast-notification-text">Please select your team size</p>
                    </div>
                </Col>
            </Row>
            <Form noValidate validated={validate}>
                <Form.Group className="team-size-form-group">
                    <Row>
                        <Col xs="5" style={{ paddingLeft: "0px"}}>
                            <TeamOption
                              name="Startup"
                              label="1-49 people"
                              selected={teamSize==="Startup"}
                              onChange={handleChange}
                              isValid={validate && !teamSize}
                            />
                        </Col>
                        <Col xs="5" style={{ paddingLeft: "0px"}}>
                            <TeamOption
                              name="Medium"
                              label="50-99 people"
                              selected={teamSize==="Medium"}
                              onChange={handleChange}
                              isValid={validate && !teamSize}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="5" style={{ paddingLeft: "0px"}}>
                            <TeamOption
                              name="Large"
                              label="100-499 people"
                              selected={teamSize==="Large"}
                              onChange={handleChange}
                              isValid={validate && !teamSize}
                            />
                        </Col>
                        <Col xs="5" style={{ paddingLeft: "0px"}}>
                            <TeamOption
                              name="Enterprise"
                              label="500+ people"
                              selected={teamSize==="Enterprise"}
                              onChange={handleChange}
                              isValid={validate && !teamSize}
                            />
                        </Col>
                    </Row>
                </Form.Group>
            </Form>
        </Container>
    );
}

TeamSize.propTypes = {
    validate: PropTypes.bool.isRequired,
    firstName: PropTypes.string.isRequired,
    onValidate: PropTypes.func.isRequired,
    teamSize: PropTypes.string
}

export default TeamSize;